import { makeStyles } from '@material-ui/core'
import palette from 'theme/palette'

const styles = makeStyles((theme) => ({
  accordion: {
    '&::before': {
      display: 'none',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  notes: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  link: {
    color: palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
}))

export default styles
